import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimLeadingSpace]'
})
export class TrimLeadingSpace {

  constructor(private ngControl: NgControl) { }
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;

    if (currentValue.startsWith(' ')) {
      const trimmed = currentValue.trimStart();
      input.value = trimmed;

      // Update form control value
      if (this.ngControl && this.ngControl.control) {
        this.ngControl.control.setValue(trimmed, { emitEvent: false });
      }
    }
  }

}
